import React from 'react'
import PropTypes from 'prop-types'
import { useLaneEditorFormLogic } from './LaneEditorForm.logic.js'
import { LaneEditorFormView } from './LaneEditorForm.view.jsx'

function LaneEditorForm({ propLane, onClose }) {
  const logic = useLaneEditorFormLogic({ propLane, onClose })
  return <LaneEditorFormView {...logic} />
}

LaneEditorForm.propTypes = {
  propLane: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default LaneEditorForm
